import { Action } from 'redux'
import { IProvenance } from '../../models/Provenance'
import { ProvenancesActions } from '../../reducers/provenances/actionNames'

export const addProvenance = (provenance: string): IRequestAddProvenance => ({
  provenance,
  type: ProvenancesActions.RequestAddProvenance,
})

export const acceptProvenance = (
  provenance: IProvenance[],
): IAcceptProvenance => ({
  provenance,
  type: ProvenancesActions.AcceptedProvenance,
})

export const rejectProvenance = (errMessage: string): IRejectProvenance => ({
  errMessage,
  type: ProvenancesActions.ProvenanceAreRejected,
})

export interface IRequestAddProvenance
  extends Action<ProvenancesActions.RequestAddProvenance> {
  provenance: string
}

export interface IAcceptProvenance
  extends Action<ProvenancesActions.AcceptedProvenance> {
  provenance: IProvenance[]
}

export interface IRejectProvenance
  extends Action<ProvenancesActions.ProvenanceAreRejected> {
  errMessage: string
}
